import React from 'react';
import './serverDown.css';
import ServerDown from '../Asset/Images/error500.svg';
import strings from '../utils/property-file/serverError.json'
import Ripple from '../component/button/ripple';
import { useNavigate } from 'react-router-dom';
import constants from "../utils/constants";
import { useEffect } from 'react';

export default function ServerError() {
    const nav = useNavigate();
    useEffect(() => {
        let status = localStorage.getItem('status')
        if (!status) {
            nav(constants.navigationLink.loginLink)
        }
    }, [])

    return (
        <div className="server-error-page">
            <div className="animation-effet-on-server-error">
                <div className='white-filter-on-server-error'></div>
                <img src={ServerDown} alt="" className='image-server-unavailable' />
            </div>
            <div className="server-unavailable-heading">
                <h1>{strings.internalServerError}</h1>
            </div>
            <div className='statement-container'>
                <p>{strings.internalServerStatement}</p>
                <ol>
                    <li>{strings.internalServerStatement2}</li>
                    <li>{strings.internalServerStatement3}</li>
                </ol>
                <center>
                    <button
                        type="submit"
                        className="btn btn-primary server-error-btn"
                        onClick={() => {
                            nav(constants.navigationLink.backPage)
                        }}>
                        <Ripple duration={1000} />
                        {strings['btn-statement']}
                    </button>
                </center>
            </div>
        </div>
    )
}
